import { useQuery } from '@apollo/react-hooks'
import { gql } from 'apollo-boost'

export interface IHawkbitDistributionSet {
  id: number
  name: string
  version: string
  description: string | null
  complete: boolean
  valid: boolean
  createdAt: number | null
  lastModifiedAt: number | null
}

export interface IHawkbitDistributionSetPage {
  content: IHawkbitDistributionSet[]
  total: number
  size: number
}

interface HawkbitDistributionSetsData {
  hawkbitDistributionSets: IHawkbitDistributionSetPage
}

interface HawkbitDistributionSetsVariables {
  limit: number
  offset: number
}

export const HAWKBIT_DISTRIBUTION_SETS_QUERY = gql`
  query HawkbitDistributionSets($limit: Int, $offset: Int) {
    hawkbitDistributionSets(limit: $limit, offset: $offset) {
      content {
        id
        name
        version
        description
        complete
        valid
        createdAt
        lastModifiedAt
      }
      total
      size
    }
  }
`

export const useHawkbitDistributionSets = ({ limit, offset }: { limit: number; offset: number }) => {
  return useQuery<HawkbitDistributionSetsData, HawkbitDistributionSetsVariables>(HAWKBIT_DISTRIBUTION_SETS_QUERY, {
    variables: { limit, offset },
    fetchPolicy: 'network-only'
  })
}
